










































import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {}
})

export default class IconsPage extends Vue {
  isLoading = true;

  async created() {
    this.isLoading = false;
  }
}
